import { YId, YPaymentProvider } from '../y/types';

export type EPaymentMethodType = 'card' | 'account' | 'paypal' | 'unknown';

export interface ELegacyPaymentMethod {
    id: YId;
    provider: YPaymentProvider;
    token: string;
    description: ELegacyPaymentMethodDescription
}

export interface ELegacyPaymentMethodDescription {
    type: EPaymentMethodType;
    bank: string;
    account: string;
    email: string;
    card_type: string;
    card_last4: string;
    exp_month: string;
    exp_year: string;
}

export function ePaymentMethodDescription(m: ELegacyPaymentMethodDescription) {
    if(m.type == 'card')
        return m.card_type + ' XXXX XXXX XXXX ' + m.card_last4;

    if(m.type == 'account')
        return m.bank + ' XXXXXXXXX ' + m.account;

    if(m.type == 'paypal')
        return "Paypal " + m.email;

    return '';
}